import React from "react";
import SearchBar from "./searchbar";

const Footer: React.FC = () => {
  return (
    <>
      <div className="w-full flex justify-center border-b-[1px]">
        <div className="w-full max-w-[1116px] h-[90px] px-8 flex items-center justify-between">
          <div
            className="text-3xl font-bold hover:text-[#5b68d3] cursor-pointer"
            onClick={() => (window.location.href = "/")}
          >
            TheAsiaWander01
          </div>

          <SearchBar />
        </div>
      </div>
    </>
  );
};

export default Footer;
